import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

export class ScheduleActivitiesFormBuilder {
  public static create(formBuilder: UntypedFormBuilder): UntypedFormGroup {
    const formGroup = formBuilder.group({});
    return formGroup;
  }
}
